import { IntlShape } from 'react-intl';

import { PaymentMethod } from '@main/types';

import { OwnershipStatus, ResidentialStatusFR } from '@main/types/insurance/france';
import { convertSnakeCaseToSentence } from '@main/utils/format';

export const formatPaymentMethod = (intl: IntlShape, paymentMethod: PaymentMethod | undefined) => {
  if (!paymentMethod || paymentMethod === PaymentMethod.UNDEFINED) {
    return intl.formatMessage({
      id: 'results.insurance-details.not-available',
      defaultMessage: 'Not available',
    });
  }
  if (paymentMethod === PaymentMethod.AUTOGIRO) {
    return intl.formatMessage({ defaultMessage: 'Direct debit' });
  }

  return convertSnakeCaseToSentence(paymentMethod);
};

export const formatOwnershipStatus = (intl: IntlShape, status: OwnershipStatus) => {
  // eslint-disable-next-line default-case
  switch (status) {
    case OwnershipStatus.OWNER:
      return intl.formatMessage({ defaultMessage: 'Owner' });
    case OwnershipStatus.SECONDARY_TENANT:
      return intl.formatMessage({ defaultMessage: 'Secondary tenant' });
    case OwnershipStatus.TENANT:
      return intl.formatMessage({ defaultMessage: 'Tenant' });
    case OwnershipStatus.UNKNOWN:
      return intl.formatMessage({
        id: 'results.insurance-details.not-available',
        defaultMessage: 'Not available',
      });
  }
};

export const formatResidentialStatusFR = (intl: IntlShape, status: ResidentialStatusFR) => {
  // eslint-disable-next-line default-case
  switch (status) {
    case ResidentialStatusFR.PRIMARY_RESIDENCE:
      return intl.formatMessage({ defaultMessage: 'Primary residence' });
    case ResidentialStatusFR.SECONDARY_RESIDENCE:
      return intl.formatMessage({ defaultMessage: 'Secondary residence' });
    case ResidentialStatusFR.RENTAL_RESIDENCE:
      return intl.formatMessage({ defaultMessage: 'Rental residence' });
    case ResidentialStatusFR.UNKNOWN:
      return intl.formatMessage({
        id: 'results.insurance-details.not-available',
        defaultMessage: 'Not available',
      });
  }
};
